import styled from "styled-components";
import { Button } from "@mui/material";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const InputGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
  color: ${({ theme }) => theme.colors.text};
  max-width: 600px;
`;

export const SubmitButton = styled(Button).attrs(({ theme }) => ({
  style: {
    color: "white",
  },
}))`
  width: 100%;
`;
